/// @flow

import { useFormContext } from 'react-hook-form';

import { useCountries, useCountry } from '@gandi/react-places';
import { createListTypeAndSort } from '@gandi/redux-places';
import { useTranslator } from '@gandi/translate';

import { Select, type Props as FieldProps } from 'src/Reshaped/Form/Select';

type Props = {
  ...Partial<FieldProps>,
  name: string,
  placeholder?: string,
};

export function StateSelect({
  disabled,
  loading,
  onChange,
  control,
  help,
  rules,
  name,
  label,
  placeholder,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const { setValue, watch } = useFormContext();

  const country = watch('country');

  const { isLoadedCountries } = useCountries();

  const { subdivisionsByType } = useCountry(country);

  const options = createListTypeAndSort(subdivisionsByType);

  return (
    <Select
      name={name}
      label={label}
      options={options}
      placeholder={country ? placeholder : __('Select a country first')}
      control={control}
      onChange={e => {
        // update the form field
        setValue(name, e.value);
        // update the parent for chain changes
        if (typeof onChange === 'function') onChange(e);
      }}
      // TODO: How to represent the loading state (reshaped)
      // isLoading={loading}
      disabled={disabled || loading || !isLoadedCountries || !country}
      rules={rules}
      help={help}
    />
  );
}
